import React, { useRef } from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";

const TrippleToggle = (props) => {
  const {
    disabled = false,
    backgroundColorLeft = "gray",
    backgroundColorRight = "success",
    backgroundColorCenter = "primary",
    neutral = false,
    bvrid,
    checked,
    onChange,
  } = props;

  const tref = useRef(null);
  const onClick = (e) => {
    const toggleRect = tref.current.getBoundingClientRect();
    const clickPosition = e.clientX - toggleRect.left;
    const toggleWidth = toggleRect.width;
    const clickRatio = clickPosition / toggleWidth;

    if (!!neutral) {
      // If neutral, move to the side that was clicked
      onChange(bvrid, {
        neutral: false,
        checked: clickRatio > 0.5, // true for right side, false for left
      });
    } else {
      // If not neutral, return to neutral position
      onChange(bvrid, {
        neutral: true,
        checked: false,
      });
    }
  };

  const backgroundColorLeftWithNumber = backgroundColorLeft.includes("-")
    ? backgroundColorLeft
    : `${backgroundColorLeft}-400`;
  const backgroundColorRightWithNumber =
    backgroundColorRight.includes("-") || backgroundColorRight === "success"
      ? backgroundColorRight
      : `${backgroundColorRight}-400`;
  const backgroundColorCenterWithNumber = backgroundColorCenter.includes("-")
    ? backgroundColorCenter
    : `${backgroundColorCenter}-400`;
  return (
    <div
      ref={tref}
      className={`flex items-center ${
        disabled ? "" : "cursor-pointer"
      } select-none`}
      onClick={disabled ? () => {} : onClick}
    >
      <div className="relative m-auto">
        <input type="checkbox" id={bvrid} className="sr-only" />
        <div
          className={`block ${
            neutral
              ? `bg-${backgroundColorCenterWithNumber}`
              : checked
                ? `bg-${backgroundColorRightWithNumber}`
                : `bg-${backgroundColorLeftWithNumber}`
          } w-14 h-8 rounded-full`}
        ></div>
        <div
          className={`absolute ${
            neutral
              ? "left-1/2 transform -translate-x-1/2"
              : checked
                ? "right-1"
                : "left-1"
          } top-1 bg-white w-6 h-6 rounded-full flex items-center justify-center`}
        ></div>
      </div>
    </div>
  );
};

export const trippleToggleControls = {
  leftLabel: {
    propType: PropTypes.string,
    controlType: "text",
    description: "Label for the left toggle option",
  },
  rightLabel: {
    propType: PropTypes.string,
    controlType: "text",
    description: "Label for the right toggle option",
  },
  disabled: {
    propType: PropTypes.bool,
    controlType: "boolean",
    description: "Disable the toggle",
  },
  checked: {
    propType: PropTypes.bool,
    controlType: "boolean",
    description: "Toggle checked state (right position)",
  },
  neutral: {
    propType: PropTypes.bool,
    controlType: "boolean",
    description: "Toggle neutral state (center position)",
  },
  bvrid: {
    propType: PropTypes.string,
    disable: true,
    description: "Unique identifier for the toggle",
  },
  backgroundColorLeft: {
    propType: PropTypes.string,
    controlType: "color",
    description: "Background color for the left option",
  },
  backgroundColorLeftDisabled: {
    propType: PropTypes.string,
    controlType: "color",
    description: "Background color for the left option when disabled",
  },
  backgroundColorRight: {
    propType: PropTypes.string,
    controlType: "color",
    description: "Background color for the right option",
  },
  backgroundColorRightDisabled: {
    propType: PropTypes.string,
    controlType: "color",
    description: "Background color for the right option when disabled",
  },
  backgroundColorCenter: {
    propType: PropTypes.string,
    controlType: "color",
    description: "Background color for the center (neutral) option",
  },
  onChange: {
    propType: PropTypes.func,
    disable: true,
    description: "Callback when toggle state changes",
  },
};

TrippleToggle.propTypes = AppUtils.getPropTypeFromControls(
  trippleToggleControls,
);

export default TrippleToggle;
